<template>
  <transition :duration="200">
    <div
      v-if="hasAlert"
      :class="{
        'w-banner': true,
        [`w-banner--${alert.type}`]: hasAlert,
      }"
    >
      <div class="w-banner__content">
        <Icon :src="alertIcon" class="w-banner__icon" />
        <span v-html="alert.message" />
        <div class="flex-grow" />
        <Icon
          src="delete"
          size="xl"
          class="cursor-pointer"
          @click="$emit('close')"
          v-if="closeable"
        />
      </div>
    </div>
  </transition>
</template>
<script>
import Icon from '@wizer/core/components/icon/Icon'

export default {
  name: 'Banner',
  components: {
    Icon,
  },
  props: {
    /**
     * Alert information object:
     *
     * {
     *   message: String,
     *   type: String,
     *   duration: Number,
     * }
     */
    alert: {
      type: Object,
      default: () => ({
        type: null,
        message: null,
      }),
    },
    /**
     * Shows or hides close button. Default: true
     */
    closeable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    hasAlert() {
      return this.alert && !!this.alert.type
    },
    alertIcon() {
      return {
        info: 'bwise/alert_info',
        success: 'bwise/checkbox_checked',
        warning: 'bwise/alert_warning',
        error: 'bwise/alert_warning',
      }[this.alert.type]
    },
  },
  watch: {
    alert(alert) {
      if (alert && alert.duration) {
        setTimeout(() => this.$emit('close'), alert.duration)
      }
    },
  },
}
</script>
<style lang="postcss">
.w-banner {
  @apply flex border-b overflow-hidden;
  @apply left-0 right-0;
  z-index: 999;
  position: absolute;
}
.w-banner__icon {
  @apply pr-2;
}
.w-banner__content {
  @apply flex flex-grow items-center p-4 text-sm mt-0;
  @apply border-l-8 border-transparent;
  transition: margin 0.2s;

  .w-banner--info & {
    @apply border-primary-500 bg-primary-100 text-primary-800;
    & .w-banner__icon {
      @apply text-primary-500;
    }
  }
  .w-banner--success & {
    @apply border-green-500 bg-green-100 text-green-800;
    & .w-banner__icon {
      @apply text-green-500;
    }
  }
  .w-banner--warning & {
    @apply border-yellow-500 bg-yellow-100 text-yellow-800;
    & .w-banner__icon {
      @apply text-yellow-500;
    }
  }
  .w-banner--error & {
    @apply border-red-500 bg-red-100 text-red-800;
    & .w-banner__icon {
      @apply text-red-500;
    }
  }
  .w-banner.v-enter &,
  .w-banner.v-leave-to & {
    @apply -mt-16;
  }
}
</style>
